export const PAYCHECKS = "PAYCHECKS";
export const PAYCHECK_COUNT = "PAYCHECK_COUNT";
export const PAYCHECK_BUSY = "PAYCHECK_BUSY";
export const PAYCHECK_SELECTED = "PAYCHECK_SELECTED";
